import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AppProvider } from './context/AppContext';
import { register } from './serviceWorkerRegistration';
import { startVersionPolling } from './versionPoller'; // 🔁 Import the version polling function

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  //</React.StrictMode>
);

// ✅ Only register service worker in production
if (process.env.NODE_ENV === 'production') {
  register();

  // ✅ Start polling version.js every 30 seconds only in production
  console.log('🚀 Starting version polling...');
  startVersionPolling(30000);
} else {
  // Optional: unregister any service workers registered in dev
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => registration.unregister());
    });
  }
}
